import React, { useEffect, useState } from 'react';
import { object, func } from 'prop-types';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import { useFormErrors } from '../../hooks/useFormErrors';
import { useForm } from '@laramie/ui';
import { FormLabel, Modal, Select, FormError } from '../../common';

const CuotaSeleccionModal = (props) => {

    const [state, setState] = useState({
        periodo: "",
        cuotas: []
    });

    const mount = () => {
        setState({
            periodo: props.data.periodo,
            cuotas: props.data.cuotas
        });
    }
    useEffect(mount, [props]);

    const [ formValues, formHandle, , formSet] = useForm({
        idEmisionCuota: 0
    });

    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const handleClickAceptar = () => {
        if (!validate()) return;

        props.onConfirm(formValues.idEmisionCuota);
    };

    function getErrors() {
        const errors = {};

        if (formValues.idEmisionCuota <= 0) errors.idEmisionCuota = VALIDATION_MESSAGE.REQUIRED_OPTION;

        return errors;
    }

    const handleClickCancelar = () => {
        props.onDismiss();
    }

    return (
        <Modal
            size="lg"
            title="Determine el periodo-cuota a ingresar"
            onEscape={handleClickCancelar}
            body={(
                <div className="row form-basic">
                    <div className="col-12">
                        <FormLabel htmlFor="idEmisionCuota" required>Periodo / Cuota</FormLabel>
                        <Select
                            name="idEmisionCuota"
                            className={`form-control ${errorOf('idEmisionCuota') ? 'is-invalid' : ''}`}
                            value={ formValues.idEmisionCuota }
                            options={state.cuotas.map(item => ({ value: item.id, label: `${state.periodo} / ${item.cuota} - ${item.descripcion}` }))}
                            onChange={ formHandle }
                        />
                        <FormError message={errorOf('idEmisionCuota')} />
                    </div>
                </div>
            )}
            footer={(<>
                <button className="btn btn-outline-primary" data-dismiss="modal" onClick={ (event) => handleClickCancelar() }>Cancelar</button>
                <button className="btn btn-primary" data-dismiss="modal" onClick={ (event) => handleClickAceptar() }>Aceptar</button>
            </>)}
        />
    );
}

CuotaSeleccionModal.propTypes = {
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

export default CuotaSeleccionModal;